enum ROUTES {
  LOGIN = 'auth/login',
  LOGOUT = 'auth/logout',
  REFRESH = 'auth/refresh',
  DEVICES = 'devices',
  STATIC_ADV_DEVICES = 'static-adv-devices',
  SETTINGS = 'settings',
  CAMPAIGNS = 'campaigns',
  ADS = 'ads',
  GEOS = 'geos',
  VIDEOS = 'videos',
  INCIDENT_TYPES = 'incident-types/',
  INCIDENTS = 'incidents',
  IMAGES = 'image-upload',
  INSTALL_DEVICE = 'install-device',
  INSTALL_STATIC_ADV = 'install-box-adv',
  INSTALL_SIDES_ADV = 'install-sides-adv',
  REMOVE_DEVICE = 'remove-device',
  REMOVE_BOX_ADV = 'remove-box-adv',
  REMOVE_SIDES_ADV = 'remove-sides-adv',
  STATIC_ADV = 'static-adv',
  TABLET_WIDGETS = 'tablet-widgets',
  STAT = 'stat',
  STAT_AGGR = 'stat/aggr',
  PARKS = 'parks',
  OPERATORS = 'operators',
  USERS = 'users',
  ORGS = 'orgs',
  SURFACE_TYPES = 'surface-types',
  DEVICE_PROFILES = 'device-profiles',
}

export default ROUTES;
